
export default {
    name: 'examen-preview-result',
    components: {},
    props: {
        demande_examen: Object,
        evolution_id: {
            type: Number,
            default: 0
        },
        toggler: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            asset_url: '',
            result_file: '',
            can_view: true,
            // asset_url: 'http://192.168.1.169/schilo/SCH_CLINIQUE/public/index.php/assets/files',
        }
    },

    watch: {
        demande_examen() {
            console.log(this.demande_examen)
            this.getFile()
        }
    },

    computed: {
        // result() {
        //     if (this.demande_examen === null) {
        //         return null;
        //     } else if (this.demande_examen.resultat === null) {
        //         return null
        //     } else {
        //         return this.demande_examen.resultat
        //     }
        // }
    },

    mounted() {
        
    },

    methods: {
        getFile() {
            if (this.demande_examen === null) {
                this.result_file = null;
            } else if (this.demande_examen.resultat === null) {
                this.asset_url = ''
                this.result_file = ''
            } else {
                this.asset_url = this.assets_path+'/files'
                this.result_file = this.demande_examen.resultat
            }
            this.can_view = this.checkIfCanViewInFrame(this.result_file)
        },

        checkIfCanViewInFrame(filename) {
            let can_view = true
            if (
                filename.includes('pdf') || filename.includes('png') || 
                filename.includes('PNG') || filename.includes('jpeg') || filename.includes('JPEG') || 
                filename.includes('jpg') || filename.includes('JPG') 
            ) {
                can_view = true
            } else {
                can_view = false
            }
            return can_view
        }
    }
}


